import { RootState } from "@/store/dtm";
import { sessionDataType  } from "@/types/applicationType"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { FinancialInstitution, Occupation, FundmoreFields, FundmoreRequestDto } from "@/lib/DTMWebAPIClient.generated";
import { currentEmploymentInfo } from "./currentEmploymentSlice";
import { assetInfo } from "./assetSlice";
import { expenseInfo } from "./expenseSlice";
import { applicantType } from "@/types/applicantType";

export interface sessionDataState {
    currentSession: sessionDataType,
}

const initialState: sessionDataState = {
    currentSession: {
        occupations: [],
        financialInstitutions: [],
        cachedApplicant: undefined,
        cachedCurrentEmployment: [],
        cachedAssets: [],
        cachedExpenses: [],
        fundmoreSSO: undefined
    }
}

export interface fundmoreSSO {
    issuer?: string | undefined;
    nameID?: string | undefined;
    request?: string | undefined;
    email?: string | undefined;
    attributes?: FundmoreFields;
}

export const sessionDataSlice = createSlice({
    name: "sessionDataSlice",
    initialState,
    reducers: {
        setOccupations: (state, action: PayloadAction<Occupation[]>) => {
            state.currentSession.occupations = action.payload;
        },
        setFinancialInstitutions: (state, action: PayloadAction<FinancialInstitution[]>) => {
            state.currentSession.financialInstitutions = action.payload.sort((a, b) => {
                if (a.name != undefined && b.name != undefined) {
                    if (a.name < b.name) return -1
                    if (a.name > b.name) return 1
                }
                return 0
            });
        },
        setCachedApplicant: (state, action: PayloadAction<applicantType | undefined>) => {
            state.currentSession.cachedApplicant = action.payload;
        },
        setCachedCurrentEmployment: (state, action: PayloadAction<currentEmploymentInfo[]>) => {
            state.currentSession.cachedCurrentEmployment = action.payload;
        },
        setCachedAssets: (state, action: PayloadAction<assetInfo[]>) => {
            state.currentSession.cachedAssets = action.payload;
        },
        setCachedExpenses: (state, action: PayloadAction<expenseInfo[]>) => {
            state.currentSession.cachedExpenses = action.payload;
        },
        clearSessionState: (state) => {
            state.currentSession.cachedApplicant = undefined;
            state.currentSession.cachedCurrentEmployment = [];
            state.currentSession.cachedAssets = [];
            state.currentSession.cachedExpenses = [];
        },
        setFundmoreSSO: (state, action: PayloadAction<fundmoreSSO | undefined>) => {
            state.currentSession.fundmoreSSO = action.payload;
        },
        clearCurrentSession: (state) => {
            state.currentSession.fundmoreSSO = undefined;
        }
    }
});

export const {
    setOccupations, setFinancialInstitutions, setCachedApplicant, setCachedCurrentEmployment, setCachedAssets, setCachedExpenses, clearSessionState,
    setFundmoreSSO,
    clearCurrentSession
} = sessionDataSlice.actions;

export const selectSessionData = (state: RootState) => state.sessionData;
export const selectOccupations = (state: RootState) => state.sessionData.currentSession.occupations;
export const selectFinancialInstitutions = (state: RootState) => state.sessionData.currentSession.financialInstitutions;
export const selectFundmoreSSO = (state: RootState) => state.sessionData.currentSession.fundmoreSSO;

export default sessionDataSlice.reducer